export default {"src":"/_next/static/media/metworx-logo.055735c4.svg","height":83,"width":590};